const DAY = 86400000;
export function productDateRange(days = 7, now = new Date()) {
  const end = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()) - DAY);
  return { from: new Date(end.getTime() - (days - 1) * DAY).toISOString().slice(0, 10), to: end.toISOString().slice(0, 10) };
}
export function eventMetric(rows, event) {
  return rows?.find(row => row.dimension === event) ?? null;
}
export function metricChange(current, previous) {
  if (current == null || previous == null) return null;
  if (previous === 0) return current === 0 ? 0 : null;
  return (current - previous) / previous;
}
// Missing dates remain unknown. This is not a zero-filled usage chart.
export function eventTrend(rows, from, to) {
  const sorted = [...(rows || [])].filter(row => /^\d{4}-\d{2}-\d{2}$/.test(row.dimension)).map(row => ({ date: row.dimension, count: row.eventCount })).sort((a, b) => a.date.localeCompare(b.date));
  if (!from || !to) return sorted;
  const byDate = new Map(sorted.map(row => [row.date, row]));
  const result = [];
  for (let value = Date.parse(`${from}T00:00:00Z`); value <= Date.parse(`${to}T00:00:00Z`); value += DAY) {
    const date = new Date(value).toISOString().slice(0, 10);
    result.push(byDate.get(date) || { date, count: null });
  }
  return result;
}

// Keep one observation scope when switching products; the selected event belongs to its product.
export function productScopeQuery(range, preset, filters) {
  const query = new URLSearchParams({ from: range.from, to: range.to, range: preset });
  if (filters.platform) query.set('platform', filters.platform);
  if (filters.appVersion) query.set('version', filters.appVersion);
  return query.toString();
}
